// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ASK_AN_EXPERT = "Poradny";
export const BACK_TO_TOPICS = "Zp\u011bt na f\u00f3ra";
export const COUNSELLING_IS_ARCHIVED = "Poradna je uzav\u0159ena";
export const FORUM = "F\u00f3ra";
export const FORUM_ADD_QUESTION = "Polo\u017e anonymn\u00ed ot\u00e1zku";
export const PREGNANCY_NEWSLETTER = "T\u011bhotensk\u00fd newsletter";
export const PREGNANCY_NEWSLETTER_DESCRIPTION = "Ka\u017ed\u00fd t\u00fdden dostane\u0161 nejd\u016fle\u017eit\u011bj\u0161\u00ed info do e-mailu";
export const PREGNANCY_NEWSLETTER_LINK_TO_PREGNANCY_CALCULATOR = "T\u011bhotensk\u00e9 kalkula\u010dce";
export const PREGNANCY_NEWSLETTER_LINK_TO_PREGNANCY_CALCULATOR_01 = "Nezn\u00e1\u0161 t\u00fdden t\u011bhotenstv\u00ed? Vypo\u010d\u00edtej si ho v";
export const PREGNANCY_NEWSLETTER_LINK_TO_PREGNANCY_CALCULATOR_AUTH = "T\u011bhotensk\u00e9 kalkula\u010dce";
export const PREGNANCY_NEWSLETTER_LINK_TO_PREGNANCY_CALCULATOR_AUTH_01 = "Nezn\u00e1\u0161 term\u00edn porodu? Vypo\u010d\u00edtej si ho v";
export const PREGNANCY_WEEKS_BOX_01 = "Zjisti v\u00edc o sv\u00e9m t\u011bhotenstv\u00ed:";
export const PREGNANCY_WEEKS_BOX_02 = "T\u011bhotenstv\u00ed t\u00fdden po t\u00fddnu";
export const REPORTED_COMMENTS = "Nahl\u00e1\u0161en\u00e9 koment\u00e1\u0159e";
export const WIKI_REVIEWS = "Centrum recenz\u00ed";
